define('photogallery.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('photogallery', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section data-view=\"GalleryView\"></section> ";
},"useData":true}, 'extensions/NetSuite/PhotoGallery/1.2.0/', 'extensions/NetSuite/PhotoGallery/1.2.0/', Handlebars);
});